import { Image } from "../vehicleDetails/vehicle-details-dto.type";

const getFilteredImagesByType = (
  images: Image[],
  imageType: "damage" | "beauty"
): Image[] => {
  if (imageType === "damage") {
    const damageImages = images.filter(
      (img) => img.imageType.toLowerCase() === "damage"
    );
    return damageImages;
  }

  const beautyImages = images.filter(
    (img) => img.imageType.toLowerCase() !== "damage"
  );
  return beautyImages;
};

export default getFilteredImagesByType;
